export default __webpack_public_path__ + "static/media/playicon.9cdb4940.png";